/** Normalise Hasura / Postgres numeric or text fields for UI. */
export function formatShopScalar(value: unknown): string | undefined {
  if (value == null || value === '') return undefined;
  if (typeof value === 'string') {
    const t = value.trim();
    return t || undefined;
  }
  if (typeof value === 'number' && Number.isFinite(value)) {
    return Number.isInteger(value)
      ? String(value)
      : String(Math.round(value));
  }
  return undefined;
}

/** Normalise shop phone for UI — digits/local format only, no country prefix injection. */
export function formatShopPhone(value: unknown): string | undefined {
  const raw = formatShopScalar(value);
  if (!raw) return undefined;
  const t = raw.trim();
  if (t.startsWith('+')) {
    const digits = t.replace(/\D/g, '');
    if (digits.startsWith('91') && digits.length > 10) {
      return digits.slice(-10);
    }
    return digits || t;
  }
  const digits = t.replace(/\D/g, '');
  if (digits.startsWith('91') && digits.length > 10) {
    return digits.slice(-10);
  }
  return digits.length >= 10 ? digits.slice(-10) : t;
}
